"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FavouriteApplicationChanged = void 0;
const wishlist_event_1 = require("./wishlist-event");
class FavouriteApplicationChanged extends wishlist_event_1.WishlistEvent {
    constructor(userId, studyId, application, eventId, stateHash, timestamp, isLocal) {
        super(timestamp);
        this.userId = userId;
        this.studyId = studyId;
        this.application = application;
        this.eventId = eventId;
        this.stateHash = stateHash;
        this.timestamp = timestamp;
        this.isLocal = isLocal;
        this.eventType = FavouriteApplicationChanged.EventType;
        this.eventVersion = '1.0.0';
    }
    static create(userId, studyId, application, stateHash, timestamp = new Date(), isLocal) {
        return new FavouriteApplicationChanged(userId, studyId, application, wishlist_event_1.WishlistEvent.generateId(), stateHash, timestamp, isLocal);
    }
}
exports.FavouriteApplicationChanged = FavouriteApplicationChanged;
FavouriteApplicationChanged.EventType = 'FavouriteApplicationChanged';
